<template>
    <div class="flex justify-center">
        <slot> </slot>
    </div>
</template>
